import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import type { ArbitroWorkspaceState } from '../../types';
import type { FontesPendenciaPublicacaoState } from '../../types/pendenciasPublicacaoTypes';
import { listarFontesPendenciaPublicacao } from './actions';

export const fontesPendenciaPublicacaoInitialState: FontesPendenciaPublicacaoState = {
  items: [],
  pagination: { page: 0, limit: 10, total: 0, totalPages: 0 },
  processoId: null,
  pendenciaId: null,
  requestId: null,
  loading: false,
  error: null,
};

export function addFontesPendenciaPublicacaoReducers(
  builder: ActionReducerMapBuilder<ArbitroWorkspaceState>,
): void {
  builder
    .addCase(listarFontesPendenciaPublicacao.pending, (state, action) => {
      const { id, pendenciaId, page = 1 } = action.meta.arg;
      if (page === 1)
        state.fontesPendenciaPublicacao = {
          ...fontesPendenciaPublicacaoInitialState,
          processoId: id,
          pendenciaId,
        };
      const atual = state.fontesPendenciaPublicacao;
      atual.requestId = action.meta.requestId;
      atual.loading = true;
      atual.error = null;
    })
    .addCase(listarFontesPendenciaPublicacao.fulfilled, (state, action) => {
      const atual = state.fontesPendenciaPublicacao;
      if (atual.requestId !== action.meta.requestId) return;
      const ids = new Set(atual.items.map((item) => item.id));
      atual.items.push(...action.payload.items.filter((item) => !ids.has(item.id)));
      atual.pagination = action.payload.pagination;
      atual.loading = false;
      atual.requestId = null;
    })
    .addCase(listarFontesPendenciaPublicacao.rejected, (state, action) => {
      const atual = state.fontesPendenciaPublicacao;
      if (atual.requestId !== action.meta.requestId) return;
      atual.loading = false;
      atual.requestId = null;
      atual.error = action.payload ?? 'Não foi possível conferir as manifestações.';
    });
}
